import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EExternalSource } from './external-sources';
import { EModel } from './model';
export const fieldsSpecialty = _extends({}, fieldsIBaseModel, {
  description: {
    type: 'Text'
  },
  directMessageAddress: {
    type: 'Text'
  },
  externalId: {
    type: 'Option',
    values: EExternalSource
  },
  externalRawSource: {
    type: 'Unknown'
  },
  name: {
    type: 'Text'
  },
  parentSpecialty: {
    type: 'ID',
    ref: EModel.Specialty
  },
  phone: {
    type: 'Text'
  },
  setting: {
    type: 'ID',
    ref: EModel.Setting
  },
  settings: {
    type: 'Object'
  }
});